<template>
  <div id="events">
    <div class="search">
      <input
        id="search-bar"
        v-model="search"
        class="search-field"
        type="text"
        placeholder="Filter events by title"
        @keyup.enter="filterEvents()"
      />
      <input
        ref="archive-search-bar"
        type="submit"
        class="search-submit"
        value="Search"
        @click="filterEvents()"
      />
      <button
        v-if="search.length > 0"
        class="clear-search-btn"
        @click="clearSearch()"
      >
        <i class="fas fa-times" />
      </button>
    </div>
    <div id="filter-results" class="bg-ghost-gray pam">
      <h4>Filter results</h4>
      <div class="filter-container">
        <div class="dept-select">
          <v-select
            ref="categorySelect"
            v-model="category"
            label="selectedDepartment"
            placeholder="Filter by owner"
            @input="filterEvents()"
            :value="categoryVal"
            :options="postTitles"
          />
        </div>
        <div class="date-pickers">
          <datepicker
            v-model="start"
            name="start"
            placeholder="Start date"
            format="MMM. dd, yyyy"
            :disabled-dates="disabledStartDate"
          />
          <i class="fa fa-arrow-right"></i>
          <datepicker
            v-model="end"
            name="end"
            placeholder="End date"
            format="MMM. dd, yyyy"
            :disabled-dates="disabledEndDate"
          />
        </div>
        <div class="clear-filters-container">
          <div class="clear-filters-button">
            <a
              class="button content-type-featured full"
              @click="clearAllFilters()"
              >Clear filters</a
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="no-events">
      <i class="fas fa-spinner fa-spin fa-3x loadingdir" />
    </div>
    <div v-if="!loading">
      <div v-for="event in filteredEvents" :key="event.event.id">
        <modal
          class="event-modal"
          :name="'modal-' + event.event.id"
          adaptive
          height="auto"
          scrollable="true"
        >
          <div class="event-icon">
            <i aria-hidden="true" class="far fa-calendar fa-lg"></i> EVENT
          </div>
          <button
            class="hide-modal-btn"
            @click="$modal.hide('modal-' + event.event.id)"
          >
            <i class="fal fa-times" />
          </button>
          <h2>{{ event.event.summary }}</h2>
          <div v-if="event.event.start.dateTime" class="event-time">
            {{ event.event.start.unixStart | formatDate }}
            <br />
            {{ event.event.start.unixStart | formatTime }} to
            {{ event.event.end.unixEnd | formatTime }}
          </div>
          <div v-if="event.event.timespan == 'All day'" class="event-time">
            {{ event.event.start.unixStart | formatDate }}
            <br />All day
          </div>
          <div
            v-if="event.event.timespan == 'Multiple days'"
            class="event-time"
          >
            <!-- SHOW DATES -->
            {{ event.event.start.unixStart | formatDate }} -
            {{ event.event.end.unixEnd | formatDate }}
          </div>
          <!-- Location -->
          <div v-if="event.event.location" class="event-location">
            <span>{{ event.event.location }}</span>
          </div>
          <br />
          <!-- Description -->
          <span v-html="event.event.description" />
          <br />
          <!-- Posted By -->
          <div v-if="event.category !== undefined && event.category.length">
            Posted by:
            <span v-for="(category, index) in event.category" :key="index">
              <a :href="getCalendarURL(category)"
                >{{ category
                }}<span v-if="index != event.category.length - 1">, </span>
              </a>
            </span>
          </div>
        </modal>

        <div
          class="single-event"
          :key="'event-' + event.event.id"
          @click="$modal.show('modal-' + event.event.id)"
        >
          <div v-if="event.event.start" class="event-date">
            <div class="month">
              {{ event.event.start.unixStart | formatMonth }}
            </div>
            <div class="day">{{ event.event.start.unixStart | formatDay }}</div>
          </div>
          <div class="event-details bg-ghost-gray">
            <div class="event-icon">
              <i aria-hidden="true" class="far fa-calendar fa-lg"></i> EVENT
            </div>
            <div class="event-title">{{ event.event.summary }}</div>

            <div v-if="event.event.start.dateTime" class="event-time">
              {{ event.event.start.unixStart | formatTime }} to
              {{ event.event.end.unixEnd | formatTime }}
            </div>
            <div v-if="event.event.timespan == 'All day'" class="event-time">
              All day
            </div>
            <div
              v-if="event.event.timespan == 'Multiple days'"
              class="event-time"
            >
              <!-- SHOW DATES -->
              {{ event.event.start.unixStart | formatDate }} -
              {{ event.event.end.unixEnd | formatDate }}
            </div>
            <div v-if="event.event.location" class="event-location">
              {{ event.event.location }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="filteredEvents.length == 0 && search !== '' && !loading"
      class="no-events"
    >
      <h3>Sorry, there are no events for {{ search }}</h3>
    </div>
    <div
      v-if="
        filteredEvents.length == 0 &&
        category !== '' &&
        category !== null &&
        search == '' &&
        !loading
      "
      class="no-events"
    >
      <h3>Sorry, there are no events for {{ category }}</h3>
    </div>
    <div
      v-if="
        filteredEvents.length == 0 &&
        (category == '' || category == null) &&
        search == '' &&
        !loading
      "
      class="no-events"
    >
      <h3>Sorry, there are no events between those dates</h3>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unreachable */
import moment from "moment";
import axios from "axios";
import vSelect from "vue-select";
import VueFuse from "vue-fuse";
import Datepicker from "vuejs-datepicker";
import VModal from "vue-js-modal";
import Vue from "vue";

Vue.use(VModal);
Vue.use(VueFuse);

const eventsEndpoint = "https://www.googleapis.com/calendar/v3/calendars/";
const client_key = "AIzaSyDbErVzyNPKfT2foVLZxCgtC-OO8FVSCUE";

const calendarsEndpoint = "https://api.phila.gov/phila/calendars/v1";
const closuresEndpoint = "https://api.phila.gov/phila/trashday/v1";
// const calendarsEndpoint = "https://localhost:19107/wp-json/calendars/v1/list";
// const calendarsEndpoint = "https://staging-www.phila.gov/wp-json/calendars/v1/list";

const today = moment().startOf("day").format();
const oneMonth = moment().add(6, "month").format();

export default {
  name: "events-archive",
  components: {
    vSelect,
    Datepicker,
  },
  data: function () {
    return {
      calendars: [],
      search: "",
      allEvents: [],
      filteredEvents: [],
      postTitles: [],
      category: "",
      categoryVal: "",
      start: today,
      end: oneMonth,
      loading: true,
      searchOptions: {
        shouldSort: false,
        threshold: 0.3,
        keys: ["event.summary"],
      },
      routerQuery: {},
    };
  },
  watch: {
    async category(value) {
      this.updateRouterQuery("category", value);
      this.loading = true;
      await this.getSingleCalendarsEvents();
      await this.filterEvents();
    },
    async start() {
      if (this.category) {
        await this.getSingleCalendarsEvents();
        await this.filterEvents();
      } else {
        this.filterEvents();
      }
    },
    async end() {
      if (this.category) {
        await this.getSingleCalendarsEvents();
        await this.filterEvents();
      } else {
        this.filterEvents();
      }
    },

    search(value) {
      this.updateRouterQuery("search", value);
    },

    routerQuery: {
      handler: function () {
        this.updateRouter();
      },
      deep: true,
    },
  },
  computed: {
    disabledEndDate: function () {
      if (this.start) {
        return {
          to: new Date(this.start),
          from: "",
        };
      }
      return {
        to: "",
        from: "",
      };
    },
    disabledStartDate: function () {
      if (this.end) {
        return {
          to: "",
          from: new Date(this.end),
        };
      }
      return {
        to: "",
        from: "",
      };
    },
  },
  filters: {
    formatMonth: function (value) {
      if (value) {
        return moment.unix(value).format("MMM");
      }
    },
    formatDay: function (value) {
      if (value) {
        return moment.unix(value).format("D");
      }
    },
    formatDate: function (value) {
      if (value) {
        return moment.unix(value).format("MMMM DD, YYYY");
      }
    },
    formatTime: function (value) {
      if (value) {
        return moment.unix(value).format("LT");
      }
    },
  },
  mounted: async function () {
    this.loading = true;
    await this.initFilters();
    this.calendars = await this.getCalendars();
    await this.fetchCategories();
    if (this.category) {
      await this.getSingleCalendarsEvents();
      await this.filterEvents();
    } else {
      await this.getAllEvents();
      await this.getClosureEvents();
      await this.filterEvents();
    }
  },
  methods: {
    getCalendars: async function () {
      let tempData = await axios.get(calendarsEndpoint).catch((e) => {
        console.log(e);
      });
      return tempData.data;
    },

    getClosureEvents: async function() {
      let closureEvents = await axios.get(closuresEndpoint).catch((e) => {
        console.log(e);
      });
      return this.handleClosureEvents(closureEvents.data.holidays);
    },

    handleClosureEvents: async function(closureEvents) {
      let vm = this;
      closureEvents.forEach(function (event) {
        let eventObject = {
          category: ["Mayor’s Office"],
          event: {
            timespan:"All day",
            summary:event.holiday_label,
            id:event.holiday_label,
            start: {
              date: new Date(event.start_date),
              unixStart:moment(event.start_date).unix()
            },
            end: {
              date: new Date(event.start_date),
              unixEnd:moment(event.start_date).unix()
            }
          }
        }
        if (!(vm.allEvents.some((ev) => ev.event.id == event.holiday_label))) {
          vm.allEvents.push(eventObject);
        } 
      });
    },

    getAllEvents: async function () {
      const calendarPromises = [];
      for (const calendar of this.calendars) {
        let cal_id = calendar.calendar;
        if (typeof cal_id === "string" && cal_id !== "") {
          calendarPromises.push(this.handleSingleCalendar(calendar, cal_id));
        } else if (typeof cal_id === "object") {
          calendarPromises.push(this.handleGroupedCalendar(calendar, cal_id));
        }
      }
      await Promise.all(calendarPromises);
    },

    getSingleCalendarsEvents: async function () {
      if (this.category === "Mayor's Office") {
        this.getClosureEvents();
      } 
      const calendarPromise = [];
      let calendar = this.calendars.filter((cal) => {
        return cal.post_title == this.category;
      });
      let cal_id = calendar[0].calendar;
      if (typeof cal_id === "string" && cal_id !== "") {
        calendarPromise.push(this.handleSingleCalendar(calendar[0], cal_id));
      } else if (typeof cal_id === "object") {
        calendarPromise.push(this.handleGroupedCalendar(calendar[0], cal_id));
      }
      await Promise.all(calendarPromise);
    },

    fetchCategories: async function () {
      for (const calendar of this.calendars) {
        this.postTitles.push(calendar.post_title);
      }
      this.postTitles = this.postTitles.sort();
    },

    handleSingleCalendar: async function (calendar, cal_id) {
      await axios
        .get(eventsEndpoint + cal_id + "/events/?key=" + client_key, {
          params: {
            timeMin: this.start,
            singleEvents: true,
            timeMax: this.end,
            orderBy: "startTime",
          },
        })
        .then(async (response) => {
          var dept = calendar.post_title;

          return Promise.all(
            response.data.items.map(async (event) => {
              const tempEvent = await this.handleEvent(event, dept);
              if (tempEvent != "") {
                this.allEvents.push(tempEvent);
              }
            })
          );
        })
        .catch((e) => console.log(e));
    },

    handleGroupedCalendar: async function (calendar, cal_id) {
      let obj_cal_ids = [];
      cal_id.forEach((cal) => {
        obj_cal_ids.push(cal.calendar);
      });
      var group_cal_id = calendar.category_slug;

      return Promise.all(
        obj_cal_ids.map(async (calid) => {
          await axios
            .get(eventsEndpoint + calid + "/events/?key=" + client_key, {
              params: {
                timeMin: this.start,
                singleEvents: true,
                timeMax: this.end,
                orderBy: "startTime",
              },
            })
            .then(async (response) => {
              var dept = this.returnGroupCategory(group_cal_id);
              return Promise.all(
                response.data.items.map(async (event) => {
                  const tempEvent = await this.handleEvent(event, dept);
                  if (tempEvent != "") {
                    this.allEvents.push(tempEvent);
                  }
                  return tempEvent;
                })
              );
            })
            .catch((e) => console.log(e));
        })
      );
    },

    handleEvent: async function (event, dept = null) {
      let tempEvent = "";
      if (event.status !== "cancelled") {
        let newStart = event.start.date
          ? moment(event.start.date).unix()
          : moment(event.start.dateTime).unix();
        let newEnd = event.end.date
          ? moment(event.end.date).unix()
          : moment(event.end.dateTime).unix();

        event.start.unixStart = newStart;
        event.end.unixEnd = newEnd;
        if (newEnd - newStart == 86400) {
          event.timespan = "All day";
        } else if (newEnd - newStart > 86400) {
          event.timespan = "Multiple days";
        } else {
          event.timespan = "Single day";
        }

        if (this.allEvents.some((ev) => ev.event.id == event.id)) {
          let existingEvent = this.allEvents.find(
            (ev) => ev.event.id == event.id
          );
          let deptArr = existingEvent.category;

          deptArr.indexOf(dept) === -1 ? existingEvent.category.push(dept) : "";
        } else {
          tempEvent = {
            category: [dept],
            event: event,
          };
        }
      }
      return tempEvent;
    },

    clearAllFilters: async function () {
      this.loading = true;
      this.search = "";
      this.category = "";
      this.start = today;
      this.end = oneMonth;
      await this.getAllEvents();
      await this.getClosureEvents();
      await this.filterEvents();
    },

    clearSearch: function () {
      this.search = "";
      this.filterEvents();
    },

    filterEvents: async function () {
      this.loading = true;
      this.filteredEvents = [];
      await this.filterByOwner().then(async (ownerFilter) => {
        await this.filterByDate(ownerFilter).then(async (dateFilter) => {
          await this.filterBySearch(dateFilter).then(async (searchFilter) => {
            this.filteredEvents = await this.sortDates(searchFilter);
          });
        });
      });
      this.loading = false;
    },

    filterBySearch: async function (dateEvents) {
      var tempEvents = [];
      if (this.search !== "") {
        await this.$search(this.search, dateEvents, this.searchOptions).then(
          (events) => {
            tempEvents = events;
          }
        );
        return tempEvents;
      } else {
        return dateEvents;
      }
    },

    filterByDate: async function (events) {
      if (this.start && this.end) {
        let queryStart = moment(
          new Date(this.start).setHours(0, 0, 0, 0)
        ).unix(); //convert to 12:00AM of the start date
        let queryEnd = moment(
          new Date(this.end).setHours(23, 59, 59, 0)
        ).unix(); //convert to 11:59pm of the end date
        // let queryStart = moment(this.start).unix(); //convert to 12:00AM of the start date
        // let queryEnd = moment(this.end).unix(); //convert to 11:59pm of the end date

        if (queryEnd >= queryStart) {
          events = events.filter(
            (event) =>
              event.event.start.unixStart >= queryStart &&
              event.event.end.unixEnd <= queryEnd
          );
        }
      }
      return events;
    },

    filterByOwner: async function () {
      if (this.category) {
        let newArr = this.allEvents.filter((event) =>
          event.category.includes(this.category)
        );
        return newArr;
      } else {
        return this.allEvents;
      }
    },

    sortDates: async function (events) {
      events = events.sort((a, b) =>
        a.event.start.unixStart > b.event.start.unixStart ? 1 : -1
      );
      return events;
    },

    returnCategory: function (id) {
      let category = this.calendars.find((cal) => cal.category_slug == id);
      if (category) {
        return category.post_title;
      }
      return "";
    },

    returnGroupCategory: function (id) {
      let category = this.calendars.find(
        (cal) => cal.category_slug == id && typeof cal.calendar === "object"
      );
      if (category) {
        return category.post_title;
      }
      return "";
    },

    returnURL: function (cal) {
      return cal.url || "";
    },

    getCalendarURL: function (postTitle) {
      let cal = this.calendars.filter((cal) => cal.post_title == postTitle);
      if (cal.length) {
        return cal[0].url || "";
      }
      return "";
    },

    updateRouterQuery: function (key, value) {
      if (!value) {
        Vue.delete(this.routerQuery, key);
      } else {
        Vue.set(this.routerQuery, key, value);
      }
    },
    resetRouterQuery: function () {
      for (let routeKey in this.$route.query) {
        Vue.delete(this.routerQuery, routeKey);
      }
    },

    updateRouter: function () {
      if (
        this.routerQuery.category !== this.$route.query.category ||
        this.routerQuery.search !== this.$route.query.search
      ) {
        this.$router
          .push({
            name: "main",
            query: this.routerQuery,
          })
          .catch((e) => {
            window.console.log(e);
          });
      }
    },

    initFilters: async function () {
      if (Object.keys(this.$route.query).length !== 0) {
        for (let routerKey in this.$route.query) {
          Vue.set(this, routerKey, this.$route.query[routerKey]);
        }
      }
      // await this.filterEvents();
    },
  },
};
</script>

<style lang="scss">
@import "node_modules/vue-select/dist/vue-select";
#events {
  max-width: 70rem;
  margin: 0 auto;
  padding-top: 20px;
}

.clear-search-btn {
  position: absolute;
  top: 16px;
  right: 70px;
  padding: 0;
  font-size: 20px;
  background-color: #fff;
  opacity: 0.8;
  z-index: 999;
  cursor: pointer;
  color: rgba(60, 60, 60, 0.5);
  &:hover {
    background: transparent;
    color: black;
  }
}

.event-modal {
  .vm--modal {
    padding: 20px;
    border-bottom: 5px rgb(58, 131, 60) solid;
    height: auto !important; 
  }
  .hide-modal-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 0;
    font-size: 20px;
    background-color: #fff;
    opacity: 0.8;
    z-index: 999;
    cursor: pointer;
    &:hover {
      color: #444;
    }
  }
}

#filter-results {
  margin-bottom: 5px;
}

.filter-container {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  .date-pickers {
    width: 40%;
    display: flex;
    justify-content: space-between;
    padding: 0px 10px 0px 0px; 
    .vdp-datepicker {
      width: 45%;
    }
    i {
      padding-top: 10px;
    }
  }
  .dept-select {
    width: 40%;
    padding: 0px 10px 0px 0px; //VSELECT STUFF AAH
    .v-select .vs__dropdown-toggle {
      border: none;
      background: white;
    }
    .v-select .vs__open-indicator path {
      bottom: 0;
      top: 0;
      right: 0;
      background: #0f4d90;
      padding: 0 0 0 9px;
      width: 30px;
      height: 100%;
      fill: #0f4d90;
    }
    .v-select .vs__actions {
      padding: 0 5px 0 0;
    }
    .v-select .vs__search {
      color: #a1a1a1;
      background: transparent;
    }
    .vs__selected {
      position: absolute;
      z-index: 2;
      white-space: nowrap;
      max-width: 340px;
      text-overflow:ellipsis;
      overflow: hidden;
    }
  
    .vs__clear {
      display: none;
    }
    .v-select .vs__dropdown-toggle {
      border-radius: 0;
      padding: 0;
    }
    .v-select .vs__dropdown-menu {
      width: 400px;
    }
    .v-select input[type="search"],
    .v-select input[type="search"]:focus {
      border: none;
    }
    .v-select .vs__open-indicator {
      border-color: white;
      cursor: pointer;
    }
    .v-select input[type="search"],
    .v-select input[type="search"]:focus {
      height: 2.4rem;
      margin: 0;
    }
    ul.vs__dropdown-menu {
      border: none;
      font-weight: bold;
      overflow-x: hidden;
    }
    ul.vs__dropdown-menu li {
      border-bottom: 1px solid #f0f0f0;
      padding: 15px 0 15px 10px;
    }
    .vs__dropdown-option--highlight.vs__dropdown-option {
      background: #0f4d90;
      color: white;
    }
  }
  .clear-filters-container{
    width: 20%;
    .clear-filters-button {
      .button{
        padding: .75rem .5rem;
      }
    }
  }
  .vdp-datepicker [type="text"] {
    height: 2.4rem;
  }
  .vdp-datepicker input:read-only {
    background: white;
    cursor: pointer;
  }
  .vdp-datepicker__calendar .cell.selected,
  .vdp-datepicker__calendar .cell.selected.highlighted,
  .vdp-datepicker__calendar .cell.selected:hover {
    background: #25cef7;
  }
  .vdp-datepicker__calendar span.prev.disabled {
    display: inline-block !important;
  }

  .vdp-datepicker__calendar span.next.disabled {
    display: inline-block !important;
  }
}

.event-icon {
  padding: 0px 0 10px 0;
  color: rgb(58, 131, 60);
  font-family: "Montserrat", "Tahoma", sans-serif;
  font-size: 0.9rem;
}

.single-event {
  padding: 5px 0px;
  display: flex;
  width: 100%;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  .event-date {
    background-color: rgb(58, 131, 60);
    color: white;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    min-width: 125px;
    min-height: 120px;
    text-align: center;
    padding: 20px;
    font-family: "Montserrat", "Tahoma", sans-serif;
    .month {
      font-size: 2rem;
      text-transform: uppercase;
      font-size: 1.2rem;
    }
    .day {
      font-size: 5rem;
      line-height: 4rem;
    }
  }
  .event-details {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 20px;
    .event-title {
      font-size: 20px;
    }
    .event-icon {
      padding: 10px 0 10px 0;
      color: rgb(58, 131, 60);
    }
    .event-time {
      padding-top: 10px;
    }
  }
}
.no-events {
  margin-top: 40px;
  text-align: center;
}

@media screen and (max-width: 768px) {
.filter-container {
  flex-direction: column;

  .dept-select {
    width:100%;
    padding-bottom: 1rem;
  }

  .vs__selected {
    max-width: 310px !important;
  }

  .date-pickers{
    width:100%;
  }

  .clear-filters-container{
    width:100%;
    .clear-filters-button {
      margin: 0 auto;
      width:40%;
    }
  }
}
}

</style>